<template>
  <div class="spo-card spo-card-shadowed rounded pa-0 overflow-hidden bg-white">

    <div ref="enteteCoureurRef">
      <EnteteCoureur :inscription="inscription" :index="index" :isFinished="isFinished"
        @deleteInscription="deleteCoureur()"></EnteteCoureur>
    </div>
    <StepperInscription v-if="!isFinished" :current_step="current_step_inscription" :index="index"
      @goToStep="goToStep($event)" class="bg-spo-light">
    </StepperInscription>
    <RecapitulatifInscription v-else :inscription="inscription" :index="index" @editInscription="goToParcoursStep()"
      @deleteInscription="deleteCoureur()">
    </RecapitulatifInscription>

    <ExpandTransition :show="current_step_inscription == '1'">
      <SelectionParcours :item="inscription" @goToNextStep="goToIdentityStep()">
      </SelectionParcours>
    </ExpandTransition>
    <ExpandTransition :show="current_step_inscription == '2'">
      <IdentiteCoureur :item="inscription" :ids_parcours="ids_selected_parcours" @onIncoherence="display_incoherence"
        @goToNextStep="goToOptionsStep()" @goToPreviousStep="goToParcoursStep()"></IdentiteCoureur>
    </ExpandTransition>
    <ExpandTransition :show="current_step_inscription == '3'">
      <SelectionOptions :item="inscription" :index_inscription="index" @goToNextStep="finishInscription()"
        @goToPreviousStep="goToIdentityStep()"></SelectionOptions>
    </ExpandTransition>


    <IncoherencePopupDialog :incoherence="incoherence_response"></IncoherencePopupDialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import SelectionParcours from "@/components/Inscription/SelectionParcours.vue";
import SelectionOptions from "@/components/Inscription/SelectionOptions.vue";
import IncoherencePopupDialog from "@/components/Inscription/IdentiteCoureur/IncoherencePopupDialog.vue";
import ExpandTransition from "@/components/App/UI/ExpandTransition.vue";
import EnteteCoureur from "@/components/Inscription/InscriptionItem/EnteteCoureur.vue";
import StepperInscription from "@/components/Inscription/InscriptionItem/StepperInscription.vue";
import RecapitulatifInscription from "@/components/Inscription/InscriptionItem/RecapitulatifInscription.vue";
export default {
  props: ["item", "index", "is_dossard_bourse"],
  components: { IdentiteCoureur, SelectionParcours, SelectionOptions, IncoherencePopupDialog, ExpandTransition, EnteteCoureur, StepperInscription, RecapitulatifInscription },

  data() {
    return {
      inscription: {},
      current_step_inscription: "1", // 1: parcours, 2: identité, 3: options, 4: finalisée
      incoherence_response: null,
      error_point_relai: false,
      allowStepScroll: false,
    };
  },
  watch: {
    current_step_inscription() {
      if (!this.allowStepScroll) {
        return;
      }
      this.scrollToEnteteCoureur();
    },
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    // Récupère les ids des parcours sélectionnés dans l'étape 1
    ids_selected_parcours() {
      let ids = [];
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected) {
          ids.push(this.inscription.list_courses.list[i].id);
        }
      }
      return ids;
    },
    isFinished() {
      return this.inscription.finished;
    },
    buyDossardBourseView() {

      return this.$route.name == "BuyDossardBourse";
    },


    champsStoreLoaded() {
      return this.mainStore.champs_formulaire.isLoaded;
    },
  },

  mounted() {
    this.allowStepScroll = true;
  },
  methods: {
    scrollToEnteteCoureur() {
      this.$nextTick(() => {
        const el = this.$refs.enteteCoureurRef;
        if (!el) {
          return;
        }
        const top = el.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top, behavior: "smooth" });
      });
    },
    display_incoherence(response) {
      if (this.mainStore.billetterie_mode) return;
      this.incoherence_response = response;
    },
    goToStep(step) {
      const stepNum = parseInt(step);
      const currentNum = parseInt(this.current_step_inscription);
      if (stepNum >= currentNum || !this.is_openable(stepNum)) {
        return;
      }
      switch (step) {
        case "1":
          this.goToParcoursStep();
          break;
        case "2":
          this.goToIdentityStep();
          break;
        case "3":
          this.goToOptionsStep();
          break;
        case "4":
          this.finishInscription();
          break;
        default:
          break;
      }
    },
    goToParcoursStep() {
      this.inscription.finished = false;
      this.current_step_inscription = "1";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
    },
    goToIdentityStep() {
      this.inscription.finished = false;
      this.current_step_inscription = "2";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
    },

    goToOptionsStep() {
      this.current_step_inscription = "3";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
      if (this.mainStore.dossard_bourse_mode || this.mainStore.parcours_billetterie_mode) {
        this.finishInscription();
      }

    },
    finishInscription() {
      if (!this.checkLivraisonAdress()) {
        return;
      }

      this.inscription.finished = true;
      this.current_step_inscription = "4";
      this.inscription.update_cart("articles", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
    },
    checkLivraisonAdress() {
      this.error_point_relai = false;
      if (!this.inscription.list_articles.infos_livraison) {
        return true;
      }
      const mode = this.inscription.list_articles.infos_livraison.mode;
      const adresse = this.inscription.list_articles.infos_livraison.adresse_point_relai;
      if (mode == "point_relai" && (!adresse || adresse == "")) {
        this.error_point_relai = true;
        return false;
      }
      return true;
    },

    deleteCoureur() {
      this.$emit("deleteItem");
    },
    getIcon(expanded, step) {
      if (expanded) {
        return "mdi-pencil";
      }
      if (parseInt(step) < parseInt(this.current_step_inscription)) {
        return "mdi-check";
      }
      return "mdi-dots-horizontal";
    },
    getColor(expanded, step) {
      if (expanded || parseInt(step) > parseInt(this.current_step_inscription)) {
        return "";
      }
      return "dark-green";
    },
    is_openable(step) {
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        if (!this.bookingStore.inscriptions[i].finished && this.index != i) {
          return false;
        }
      }
      return parseInt(step) < parseInt(this.current_step_inscription);
    },
  },

  created() {
    this.inscription = this.item;
    // Si l'inscription est terminée, les tiroirs sont fermés
    if (this.inscription.finished) {
      this.current_step_inscription = "4";
    }
    // Si la billetterie est ouverte, on passe directement à l'étape d'identité, car pas de sélection de parcours
    if (this.mainStore.billetterie_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
    if (this.mainStore.dossard_bourse_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
  },
};
</script>

<style lang="scss" scoped></style>